import { render, staticRenderFns } from "./expertDetail.vue?vue&type=template&id=245c4f81&scoped=true&"
import script from "./expertDetail.vue?vue&type=script&lang=js&"
export * from "./expertDetail.vue?vue&type=script&lang=js&"
import style0 from "./expertDetail.vue?vue&type=style&index=0&id=245c4f81&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245c4f81",
  null
  
)

export default component.exports